const VENDOR_PROMOTION_FORM: BannerStep[] = [
	{
		step: 1,
		isStepDisabled: false,
		title: "Select Banner Type",
		note: "Is this a paid for sponsorship banner or internal marketing?",
		type: "radio",
		radioAnswers: [
			{
				name: "Internal",
				order: 1
			},
			{
				name: "Sponsored",
				order: 1
			}
		],
		fields: null,
		value: ""
	},
	{
		step: 2,
		isStepDisabled: false,
		title: "Add Image",
		note: "jpg or png, 1000 x 563px, max 3 Mb",
		type: "multiField",
		fields: [
			{
				type: null,
				label: "",
				field: "",
				order: 1,
				placeholder: "",
				maxChar: null,
				radioAnswers: null,
				givenAnswer: "",
				preview: "",
				file: "",
				fileHelperText: ""
			},
			{
				type: "file",
				label: "",
				field: "imageLandscape",
				order: 2,
				placeholder: "Upload image",
				maxChar: null,
				radioAnswers: null,
				givenAnswer: "",
				preview: "",
				file: "",
				fileHelperText:
					"Image (jpg or png) size 1000px width x 563px height and up to 3 Mb",
				imageProfile: "retail-app-homepage-promotion"
			}
		],
		radioAnswers: null
	},
	{
		step: 3,
		isStepDisabled: false,
		title: "Add Video",
		note: "Video (mp4 or mov)",
		type: "videoUpload",
		value: "",
		preview: "",
		radioAnswers: null,
		fields: null,
		file: ""
	},
	{
		step: 4,
		isStepDisabled: false,
		title: "Content Box",
		note: null,
		type: "multiField",
		radioAnswers: null,
		fields: [
			{
				type: null,
				label: "",
				field: "",
				order: 1,
				givenAnswer: "",
				radioAnswers: null,
				maxChar: null
			},
			{
				type: "text",
				label: "Heading text",
				field: "heading",
				order: 2,
				placeholder: "Maximum heading count is 80 characters.",
				maxChar: 80,
				givenAnswer: "",
				radioAnswers: null
			},
			{
				type: "textarea",
				label: "Content text",
				field: "content",
				order: 3,
				placeholder: "Maximum content count is 160 characters.",
				maxChar: 160,
				givenAnswer: "",
				radioAnswers: null
			}
		]
	},
	{
		step: 5,
		isStepDisabled: false,
		title: "Button",
		note: null,
		type: "multiField",
		fields: [
			{
				type: null,
				label: "",
				field: "",
				order: 1,
				givenAnswer: "",
				radioAnswers: null,
				maxChar: null
			},
			{
				type: "text",
				label: "Button text",
				field: "buttonText",
				order: 2,
				placeholder: "Maximum button count is 35 characters.",
				maxChar: 35,
				givenAnswer: "",
				radioAnswers: null
			},
			{
				type: "text",
				label: "URL",
				field: "buttonLink",
				order: 3,
				placeholder: "e.g. google.com",
				maxChar: null,
				givenAnswer: "",
				radioAnswers: null,
				optional: true,
				isUrl: true
			},
			{
				type: null,
				label: "",
				field: "",
				order: 4,
				givenAnswer: "",
				radioAnswers: null,
				maxChar: null
			}
		],
		radioAnswers: null
	},
	{
		step: 6,
		isStepDisabled: false,
		title: "Banner Name",
		note: null,
		type: "multiField",
		fields: [
			{
				type: "text",
				label: "Banner name",
				field: "bannerName",
				order: 1,
				placeholder: "Banner name",
				maxChar: null,
				radioAnswers: null,
				givenAnswer: ""
			}
		],
		radioAnswers: null
	}
];

export default VENDOR_PROMOTION_FORM;
